import { ChevronDownIcon } from 'lucide-react-native';
import { forwardRef } from 'react';
import { type GetProps, type Input as BaseInput } from 'tamagui';

import type { IconType } from '../icons/Icon';
import { Input } from './Input';

interface InputTriggerProps extends GetProps<typeof Input> {
    onTrigger: () => void;
    icon?: IconType; // TODO: reconcile with Input prop 'rightIcon'
}

export const InputTrigger = forwardRef<BaseInput, InputTriggerProps>(
    ({ onTrigger, icon, ...props }, ref) => {
        return (
            <Input
                {...props}
                ref={ref}
                onPressIn={onTrigger}
                editable={false}
                rightIcon={icon ?? props.rightIcon ?? ChevronDownIcon}
                cursor="pointer"
                onPressIcon={onTrigger}
            />
        );
    },
);
